// src/utils/generateId.ts

/**
 * Generates a unique ID for bills.
 * Uses crypto.randomUUID() with fallback for older browsers.
 * Prefixed with timestamp for sortability.
 */
export function generateBillId(): string {
	const timestamp = Date.now().toString(36);

	// Use crypto.randomUUID if available (modern browsers)
	if (typeof crypto !== 'undefined' && crypto.randomUUID) {
		return `${timestamp}-${crypto.randomUUID()}`;
	}

	// Fallback for older browsers
	const random =
		Math.random().toString(36).substring(2, 15) +
		Math.random().toString(36).substring(2, 15);
	return `${timestamp}-${random}`;
}
